@let canSendFeedback = last || (!last && item.like === undefined);
@let attachment = attachmentDetail$ | async;
@let messagesCount = messagesCount$ | async;
@let hasErrors = hasErrors$ | async;
<article class="flex flex-col gap-y-8">
    <!--
         Who is speaking is conveyed only by position, background colour and the
         AInteracta icon, none of which reach a screen reader.
     -->
    <span class="sr-only">
        {{
            (item.role === AIRole.MODEL
                ? 'AI.ACCESSIBILITY.MESSAGE_FROM_AI'
                : 'AI.ACCESSIBILITY.MESSAGE_FROM_USER'
            ) | translate
        }}
    </span>
    @if (item.messageType !== AIMessageType.ATTACHMENT) {
        <section
            class="flex w-full"
            [ngClass]="{
                'justify-end': item.role === AIRole.USER,
                'justify-start': item.role === AIRole.MODEL,
            }"
        >
            <section
                class="flex flex-col gap-y-8 px-12 py-8 typo-sm shadow-chat"
                [ngClass]="{
                    'max-w-1/2 rounded-l-2xl rounded-tr-2xl bg-surface-chat-A':
                        item.role === AIRole.USER,
                    'w-full rounded-tl-2xl rounded-r-2xl bg-surface-A':
                        item.role === AIRole.MODEL,
                }"
            >
                <section class="flex gap-x-8">
                    @if (item.role === AIRole.MODEL) {
                        <interacta-image
                            alt=""
                            class="shrink-0"
                            [classes]="'size-24'"
                            [src]="
                                theme === 'dark'
                                    ? './assets/shared/images/ai/ai-interacta-logo_dark.svg'
                                    : './assets/shared/images/ai/ai-interacta-logo_light.svg'
                            "
                        />
                    }

                    <div class="relative grow overflow-hidden">
                        <p
                            class="inline w-full wrap-break-word"
                            [innerHtml]="displayedMessage() | safeHtml"
                        ></p>
                        <span
                            class="inline-block w-80"
                            [attr.aria-hidden]="true"
                        ></span>
                        <time
                            class="absolute right-12 bottom-0 text-text-mid-contrast"
                            >{{ item.timestamp | interactaDate: 'time' }}</time
                        >
                    </div>
                </section>
                @if (item.messageType !== AIMessageType.EXAMPLE) {
                    @if (
                        item.role === AIRole.MODEL &&
                        [AIMessageType.STANDARD, AIMessageType.ERROR].includes(
                            item.messageType
                        )
                    ) {
                        <interacta-separator [thickness]="'soft'" />
                    }
                    @if (item.role === AIRole.MODEL) {
                        <section class="flex items-center gap-x-8">
                            @if (item.messageType === AIMessageType.STANDARD) {
                                <button
                                    interacta-toggle-icon-button
                                    type="button"
                                    [disabled]="!canSendFeedback"
                                    [icon]="'thumb-up'"
                                    [label]="'AI.LIKE' | translate"
                                    [selected]="item.like === true"
                                    [size]="'small'"
                                    (click)="setLike(item.like, true)"
                                ></button>
                                <button
                                    interacta-toggle-icon-button
                                    type="button"
                                    [disabled]="!canSendFeedback"
                                    [icon]="'thumb-down'"
                                    [label]="'AI.DISLIKE' | translate"
                                    [selected]="item.like === false"
                                    [size]="'small'"
                                    (click)="setLike(item.like, false)"
                                ></button>
                                <button
                                    interacta-icon-button
                                    type="button"
                                    [icon]="'copy'"
                                    [label]="'AI.COPY' | translate"
                                    [size]="'small'"
                                    [style]="'text'"
                                    (click)="copyText()"
                                ></button>
                            } @else if (
                                item.messageType === AIMessageType.ERROR
                            ) {
                                <button
                                    interacta-button
                                    type="button"
                                    [icon]="'retry'"
                                    [label]="'SHARED.BUTTON.RETRY' | translate"
                                    (click)="retry.emit()"
                                ></button>
                            }
                        </section>
                    }
                }
            </section>
        </section>
    } @else {
        <section class="flex w-full flex-col items-end justify-center">
            @if (attachment) {
                <interacta-ai-message-attachment-chip
                    class="max-w-1/2 min-w-352"
                    [attachment]="attachment"
                    [hasErrors]="hasErrors ?? false"
                    [messagesCount]="messagesCount ?? 0"
                    [showThreadButton]="threadId === MAIN_THREAD"
                    (attachmentClicked)="openAttachmentPreview.emit(attachment)"
                    (goToThread)="goToThread.emit(attachment.id)"
                />
            } @else {
                <div
                    class="h-100 w-352 animate-pulse rounded-2xl bg-surface-300"
                ></div>
            }
            @if (threadId !== MAIN_THREAD) {
                <interacta-separator
                    class="mt-12 mb-16 w-full"
                    [thickness]="'soft'"
                />
            }
        </section>
    }
    @if (item.role === AIRole.MODEL) {
        <interacta-ai-feedback
            [like]="item.like"
            (sendFeedbackDetail)="sendFeedbackDetail($event)"
        />
    }
</article>
